module.exports = __webpack_public_path__ + "img/90BF486898ED4D85.460e11b5.png";